import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	roles: [],
	roleData: [],
};

const rolePermissionsSlice = createSlice({
	name: "rolePermissions",
	initialState,
	reducers: {
		setRoles(state, action) {
			state.roles = action.payload;
		},
		setRoleData(state, action) {
			state.roleData = action.payload;
		},
	},
});

export const { setRoles, setRoleData } = rolePermissionsSlice.actions;
export default rolePermissionsSlice.reducer;
